jQuery(document).ready(function($) {

    $('.industries-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        prevArrow: '<button class="slick-prev" aria-label="Previous"><span class="fa fa-chevron-left"></span></button>',
        nextArrow: '<button class="slick-next" aria-label="Next"><span class="fa fa-chevron-right"></span></button>',
        dots: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

});